import { render, staticRenderFns } from "./ChoiceSelectionCard.vue?vue&type=template&id=1a63efa0"
import script from "./ChoiceSelectionCard.vue?vue&type=script&lang=js"
export * from "./ChoiceSelectionCard.vue?vue&type=script&lang=js"
import style0 from "./ChoiceSelectionCard.vue?vue&type=style&index=0&id=1a63efa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports